import { SummitIdObject } from './summit-id-object';

export class BasicListItem extends SummitIdObject {
  declare id: number;
  label?: string;
  value?: string;

  constructor(jsonData?: Partial<BasicListItem>) {
    super(jsonData);
  }
}
